export const SET_REQUESTED_EMAIL = "SET_REQUESTED_EMAIL";
export const SET_NEW_PASSWORD = "SET_NEW_PASSWORD";
export const PASSWORD_RESET_REQUEST_SUCCESS = "PASSWORD_RESET_REQUEST_SUCCESS";
export const PASSWORD_RESET_ERROR = "PASSWORD_RESET_ERROR";